export function canInsertChild(nodes) {
    return [...nodes].filter(
        node => this.actions.canInsertChild(node)
    )
}

export async function appendChild(nodes) {
    await this.execute(
        () => this.actions.appendChild(nodes)
    )
}

export async function prependChild(nodes) {
    await this.execute(
        () => this.actions.prependChild(nodes)
    )
}
